<template>
  <p>Empty</p>
</template>

<script>
export default {};
</script>

<style>
</style>